const prefix = 'formfield';
export const dataHooks = {
    suffix: `${prefix}-suffix`,
    labelIndicators: `${prefix}-indicators`,
    counter: `${prefix}-counter`,
    children: `${prefix}-children`,
    label: `${prefix}-label`,
    asterisk: `${prefix}-asterisk`,
    infoIcon: `${prefix}-infoicon`,
    statusMessage: `${prefix}-statusmessage`,
};
//# sourceMappingURL=constants.js.map